import { CSS } from '@dnd-kit/utilities';

export const dropAnimationConfig = {
  keyframes({ transform }: { transform: any }) {
    return [
      { transform: CSS.Transform.toString(transform.initial) },
      {
        transform: CSS.Transform.toString({
          ...transform.final,
          scaleX: 0.94,
          scaleY: 0.94,
        }),
      },
    ];
  },
  sideEffects({ active, dragOverlay }: { active: any; dragOverlay: any }) {
    active.node.style.opacity = '0';

    const itemNode = dragOverlay.node;

    if (itemNode) {
      itemNode.animate(
        [
          {
            boxShadow:
              '-1px 0 15px 0 rgba(34, 33, 81, 0.01), 0px 15px 15px 0 rgba(34, 33, 81, 0.25)',
          },
          {
            boxShadow:
              '-1px 0 15px 0 rgba(34, 33, 81, 0), 0px 15px 15px 0 rgba(34, 33, 81, 0)',
          },
        ],
        {
          duration: 250,
          easing: 'ease',
          fill: 'forwards',
        },
      );
    }

    return () => {
      active.node.style.opacity = '';
    };
  },
};
